import { Card, CardContent, Stack } from '@mui/joy';
import { useTranslation } from 'react-i18next';

import { LabeledValue } from 'core/elements';
import { useFormContext } from 'core/states';
import { Direction, Variant } from 'theme/enums';

export const CorporateLocationDetails = ({
  isAlternateVersionEnabled,
}: {
  isAlternateVersionEnabled: boolean;
}) => {
  const { t } = useTranslation();

  const { watch } = useFormContext();

  const locationValue = watch('location');

  if (!locationValue) {
    return null;
  }

  return (
    <Card variant={Variant.PLAIN}>
      <CardContent>
        <Stack direction={Direction.COLUMN} spacing={1}>
          <LabeledValue label={t('labelLocationName')} value={locationValue.name} />

          {isAlternateVersionEnabled && locationValue.externalLocationId && (
            <LabeledValue
              label={t('labelExternalLocationId')}
              value={locationValue.externalLocationId}
            />
          )}

          {!isAlternateVersionEnabled && locationValue.vendorId && (
            <LabeledValue label={t('labelVendorId')} value={locationValue.vendorId} />
          )}
        </Stack>
      </CardContent>
    </Card>
  );
};
